module.exports = __webpack_public_path__ + "img/etienne-daho.7bd6e7dc.jpg";